/**
 * The one look for every tab strip nested under a shell's own navigation (the user's rule, 19 October 2026): a framed
 * row of buttons, the chosen one filled in marine. The shells' top-level navigation keeps its own underline, so the
 * two levels read differently. A strip built by hand (a badge or a marker inside a tab) uses these classes rather than
 * its own, inside `TabStrip`, which keeps the row on one line and scrolls it when it is too wide.
 */
export const SEGMENTED_TABLIST_CLASS = 'inline-flex max-w-full gap-1 rounded-lg border border-marine/20 bg-white p-1 shadow-sm'

export function segmentedTabClass(active: boolean): string {
  return `shrink-0 whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-bold transition-colors ${active ? 'bg-marine text-white shadow-sm' : 'text-ink-mid hover:bg-canvas hover:text-ink'}`
}
